<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" class="mt-1 text-center">
        <h1>Add Exam Question</h1>
        <b-button
          variant="outline-success"
          class="float-right"
          @click="submitQuestion"
        >Save Question</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mt-1 text-left" style="height:470px; overflow-y:auto;">
        <h2>Add New Question</h2>
        <b-form>
          <b-form-group label="Trainig Subject *">
            <b-form-select
              v-model="$v.form.selected.$model"
              :state="$v.form.selected.$dirty ? !$v.form.selected.$error : null"
              :options="optionSubjects"
              @blur.native="onSelectChange"
            ></b-form-select>
            <b-form-invalid-feedback
              class="error"
              v-if="!$v.form.selected.required"
            >This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Question Type *">
            <b-form-radio-group
              id="radio-group-1"
              v-model="$v.form.selectedQuestionType.$model"
              :state="$v.form.selectedQuestionType.$dirty ? !$v.form.selectedQuestionType.$error : null"
              :options="optionsQuestionType"
              name="radio-options"
            ></b-form-radio-group>
            <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Time Limit *">
            <b-input-group append="Mins" class="mb-1">
              <b-input
                type="number"
                v-model="$v.form.timeLimits.$model"
                :state="$v.form.timeLimits.$dirty ? !$v.form.timeLimits.$error : null"
                placeholder="3"
              ></b-input>
              <b-form-invalid-feedback>This is a required field must enter time limit</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="isCompolsory" value="0">Is Complusory?</b-form-checkbox>
            <b-form-checkbox v-model="is_practice_question" value="1">Is practice question?</b-form-checkbox>
          </b-form-group>
          <b-form-group label="Question *" label-for="input-1">
            <b-form-textarea
              placeholder="Enter your question..."
              v-model="$v.form.enterQuestion.$model"
              :state="$v.form.enterQuestion.$dirty ? !$v.form.enterQuestion.$error : null"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <b-form-invalid-feedback>This is a required field and must be at least 10 characters.</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="score *">
            <b-input
              type="number"
              v-model="$v.form.enterScore.$model"
              :state="$v.form.enterScore.$dirty ? !$v.form.enterScore.$error : null"
            ></b-input>
            <b-form-invalid-feedback>This is a required field must enter score</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Question Level *">
            <b-form-radio-group
              v-model="$v.form.questionLevel.$model"
              :state="$v.form.questionLevel.$dirty ? !$v.form.questionLevel.$error : null"
              :options="optionsQuestionLevel"
              name="radio-options"
            ></b-form-radio-group>
            <b-form-invalid-feedback>This is a required field and must be select One option</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Image">
            <vue-dropzone
              ref="myVueDropzone"
              @vdropzone-success="vsuccess"
              id="dropzone"
              :options="dropzoneOptions"
              class="m-5"
              style="border:dashed 1px"
            ></vue-dropzone>
          </b-form-group>
        </b-form>
      </b-col>
      <!-- Answer Form Starts here -->
      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
        v-if="form.selectedQuestionType === 0"
        class="mt-1 text-left"
      >
        <h3>Please select any question type</h3>
      </b-col>

      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
        v-if="form.selectedQuestionType === 1"
        class="mt-1 text-left"
      >
        <h1>Multi Choice</h1>
        <b-form-group>
          <b-form-radio-group
            v-model="$v.form.shuffleAnswer.$model"
            :state="$v.form.shuffleAnswer.$dirty ? !$v.form.shuffleAnswer.$error : null"
            id="radio-group-2"
          >
            <b-form-radio name="some-radios" value="0">Shuffle answers</b-form-radio>
            <b-form-radio name="some-radios" value="0">Show in current order</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Answer *">
          <b-form-textarea
            id="textarea"
            v-model="$v.answerFormMultiChoice.addAnswer.$model"
            :state="$v.answerFormMultiChoice.addAnswer.$dirty ? !$v.answerFormMultiChoice.addAnswer.$error : null"
            placeholder="Enter a possible answer here"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-checkbox v-model="answerFormMultiChoice.ifCorrect" value="true">Is Correct Answer?</b-form-checkbox>

        <b-form-row class="float-right">
          <b-button variant="outline-warning" class="mr-2" @click="reset">reset</b-button>
          <b-button
            variant="outline-primary"
            class="mr-2"
            :disabled="$v.answerFormMultiChoice.$invalid"
            @click="addItemMultiChoice"
          >Add</b-button>
        </b-form-row>
        <div class="clearfix"></div>

        <br />
        <b-table-simple>
          <thead>
            <tr>
              <th>Answer</th>
              <th>Is Correct</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tr v-for="item in rowDataMultiChoice">
            <td>{{ item.addAnswer }}</td>
            <td>{{ item.ifCorrect }}</td>
            <td>
              <font-awesome-icon
                v-b-tooltip.hover
                title="Delete Answer"
                icon="trash"
                :class="'ml-2 text-danger'"
                @click="removeRowMultiChoice(item)"
              />
              <font-awesome-icon
                v-b-tooltip.hover
                title="Edit Answer"
                class="ml-2 text-primary"
                icon="edit"
                @click="editAnswerModal(item)"
              />
            </td>
          </tr>
        </b-table-simple>
      </b-col>
      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
        v-if="form.selectedQuestionType === 2"
        class="mt-1 text-left"
      >
        <h1>Fill in the blanks</h1>
        <b-form-group>
          <b-form-radio-group
            v-model="$v.form.shuffleAnswer.$model"
            :state="$v.form.shuffleAnswer.$dirty ? !$v.form.shuffleAnswer.$error : null"
            id="radio-group-2"
          >
            <b-form-radio name="some-radios" value="A">Shuffle answers</b-form-radio>
            <b-form-radio name="some-radios" value="B">Show in current order</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Answer *">
          <b-form-textarea
            id="textarea"
            v-model="$v.answerFormFillInBlanks.addAnswer.$model"
            :state="$v.answerFormFillInBlanks.addAnswer.$dirty ? !$v.answerFormFillInBlanks.addAnswer.$error : null"
            placeholder="Enter a possible answer here"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-checkbox v-model="answerFormFillInBlanks.ifCorrect" value="true">Is Correct Answer?</b-form-checkbox>

        <b-form-row class="float-right">
          <b-button variant="outline-warning" class="mr-2" @click="reset">reset</b-button>
          <b-button
            variant="outline-primary"
            class="mr-2"
            :disabled="$v.answerFormFillInBlanks.$invalid"
            @click="addItemFillInBlanks"
          >Add</b-button>
        </b-form-row>
        <div class="clearfix"></div>

        <br />
        <b-table-simple>
          <thead>
            <tr>
              <th>Answer</th>
              <th>Is Correct</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tr v-for="item in rowDataFillInBlanks">
            <td>{{ item.addAnswer }}</td>
            <td>{{ item.ifCorrect }}</td>
            <td>
              <font-awesome-icon
                v-b-tooltip.hover
                title="Delete Answer"
                icon="trash"
                :class="'ml-2 text-danger'"
                @click="removeRowFillInBlanks(item)"
              />
              <font-awesome-icon
                v-b-tooltip.hover
                title="Edit Answer"
                class="ml-2 text-primary"
                icon="edit"
                @click="editAnswerModal(item)"
              />
            </td>
          </tr>
        </b-table-simple>
      </b-col>
      <b-col
        cols="6"
        style="height:470px; overflow-y:auto;"
        v-if="form.selectedQuestionType === 3"
        class="mt-1 text-left"
      >
        <h1>Free text</h1>
      </b-col>
    </b-row>
    <b-modal id="bv-modal-editAnswer" v-model="showEditModal" no-close-on-backdrop hide-footer>
      <template v-slot:modal-header="{ close }">
        <h5>Edit Answer</h5>
      </template>
      <b-form-group label="Answer">
        <b-form-textarea
          id="textarea"
          v-model="$v.editAnswerForm.addAnswer.$model"
          :state="$v.editAnswerForm.addAnswer.$dirty ? !$v.editAnswerForm.addAnswer.$error : null"
          placeholder="Enter a possible answer here"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
      </b-form-group>
      <b-form-checkbox v-model="editAnswerForm.ifCorrect" value="true">Is Correct Answer?</b-form-checkbox>
      <div class="float-right">
        <b-button
          class="mr-3"
          id="close-btn"
          variant="danger"
          @click="$bvModal.hide('bv-modal-editAnswer')"
        >Close</b-button>
        <b-button
          variant="outline-success"
          :disabled="$v.editAnswerForm.$invalid"
          @click="updateAnswer"
        >Update Answer</b-button>
      </div>
    </b-modal>

    <b-modal
      id="submit-question-modal"
      ok-only
      ok-title="Close"
      no-close-on-backdrop
      hide-footer
      size="sm"
      v-model="showModal"
      scrollable
    >
      <template v-slot:modal-header="{ close }">
        <h5>Create Question</h5>
      </template>
      <div v-if="!submiting && !responseSuccess">
        <p>Are you sure you would like to create the question</p>
      </div>
      <div v-else-if="submiting && !responseSuccess">
        <p>Your Form is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your question has been created successfully.
          <br />
        </p>
      </div>
      <div class="float-right">
        <b-button
          size="sm"
          variant="danger"
          class="mr-3"
          v-if="!submiting"
          @click="resetFormModal"
        >Close</b-button>
        <!-- Button with custom close trigger value -->
        <b-button
          size="sm"
          v-if="!responseSuccess"
          :disabled="submiting"
          variant="outline-success"
          @click="postData"
        >Submit</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "ExamQuestions",
  mixins: [validationMixin],
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      isLoading: false,
      submiting: false,
      responseSuccess: false,
      showModal: false,
      showEditModal: false,
      rowDataMultiChoice: [],
      rowDataFillInBlanks: [],
      form: {
        selected: null,
        selectedQuestionType: 0,
        timeLimits: null,
        enterQuestion: null,
        enterScore: null,
        questionLevel: null,
        shuffleAnswer: null,
        infoGraphic: null
      },
      answerFormMultiChoice: {
        ifCorrect: false,
        addAnswer: ""
      },
      answerFormFillInBlanks: {
        ifCorrect: false,
        addAnswer: ""
      },
      editAnswerForm: {
        ifCorrect: false,
        addAnswer: "",
        id: null
      },
      isCompolsory: false,
      is_practice_question: false,
      optionsQuestionType: [],
      optionSubjects: [
        {
          value: null,
          text: "Please select some item"
        },
        {
          text: "Anti money laundering",
          value: "radio"
        },
        {
          text: "Anti Bribery",
          value: "checkbox"
        },
        {
          text: "Anti corruption",
          value: "button"
        }
      ],
      optionsQuestionLevel: [
        {
          value: 1,
          text: "Basic"
        },
        {
          value: 2,
          text: "Intermediate"
        },
        {
          value: 3,
          text: "Advanced"
        },
        {
          value: 4,
          text: "Professional"
        },
        {
          value: 5,
          text: "Expert"
        }
      ],

      // dropzone options
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 10,
        headers: { "My-Awesome-Header": "header value" }
      }
    };
  },
  validations: {
    form: {
      selected: {
        required
      },
      selectedQuestionType: {
        required
      },
      timeLimits: {
        required
      },
      enterQuestion: {
        required,
        minLength: minLength(10)
      },
      enterScore: {
        required
      },
      questionLevel: {
        required
      },
      shuffleAnswer: {
        required
      }
    },
    answerFormMultiChoice: {
      addAnswer: {
        required,
        minLength: minLength(5)
      }
    },
    answerFormFillInBlanks: {
      addAnswer: {
        required,
        minLength: minLength(5)
      }
    },
    editAnswerForm: {
      addAnswer: {
        required,
        minLength: minLength(5)
      }
    }
  },
  computed: {
    ...mapGetters({
    })
  },
  mounted() {
    this.$nextTick(function() {
      this.getQuestionType().then(res => {
        this.optionsQuestionType = res;
        this.form.selectedQuestionType = 1;
      });
    });
  },
  methods: {
    ...mapActions(["setLanguage"]),
    ...mapMutations(["TOGGLE_LOADER"]),
    resetFormModal() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    submitQuestion() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.showModal = true;
    },
    reset() {
      this.$v.$reset();
      (this.answerFormMultiChoice.addAnswer = null),
        (this.answerFormMultiChoice.ifCorrect = false);
    },
    onSelectChange() {
      this.$v.form.selected.$touch();
    },
    addItemMultiChoice() {
      this.$v.answerFormMultiChoice.$touch();
      if (this.$v.answerFormMultiChoice.$anyError) {
        return;
      }
      var my_object = {
        id: Date.now(),
        addAnswer: this.answerFormMultiChoice.addAnswer,
        ifCorrect: this.answerFormMultiChoice.ifCorrect ? "Yes" : "No"
      };
      this.rowDataMultiChoice.push(my_object);
      this.$v.$reset();
      (this.answerFormMultiChoice.addAnswer = null),
        (this.answerFormMultiChoice.ifCorrect = false);
    },
    removeRowMultiChoice(index) {
      this.rowDataMultiChoice.splice(index, 1);
    },
    removeRowFillInBlanks(index) {
      this.rowDataFillInBlanks.splice(index, 1);
    },
    addItemFillInBlanks() {
      this.$v.answerFormFillInBlanks.$touch();
      if (this.$v.answerFormFillInBlanks.$anyError) {
        return;
      }
      var my_object = {
        id: Date.now(),
        addAnswer: this.answerFormFillInBlanks.addAnswer,
        ifCorrect: this.answerFormFillInBlanks.ifCorrect ? "Yes" : "No"
      };
      this.rowDataFillInBlanks.push(my_object);
      this.$v.$reset();
      (this.answerFormFillInBlanks.addAnswer = null),
        (this.answerFormFillInBlanks.ifCorrect = false);
    },
    editAnswerModal(rowDataMultiChoice) {
      this.showEditModal = true;
      this.editAnswerForm.addAnswer = rowDataMultiChoice.addAnswer;
      this.editAnswerForm.id = rowDataMultiChoice.id;
      this.editAnswerForm.ifCorrect =
        rowDataMultiChoice.ifCorrect === "Yes" ? true : false;
    },
    updateAnswer(index) {
      this.$v.editAnswerForm.$touch();
      if (this.$v.editAnswerForm.$anyError) {
        return;
      }
      var my_object = {
        addAnswer: this.editAnswerForm.addAnswer,
        ifCorrect: this.editAnswerForm.ifCorrect ? "Yes" : "No"
      };
      this.rowDataMultiChoice.push(my_object);
      this.rowDataMultiChoice.splice(index, 1);
      this.showEditModal = false;
    },
    async createQuestionApiCall() {
      const option = JSON.stringify(this.rowDataMultiChoice);
      this.formData = {
        question_category_id: localStorage.getItem("userId"),
        question_type_id: this.form.selectedQuestionType,
        question: this.form.enterQuestion,
        options: option,
        score: this.form.enterScore,
        shuffle_answers: this.form.shuffleAnswer,
        question_level: this.form.questionLevel,
        is_practice_question: this.is_practice_question,
        is_complusory: this.isCompolsory,
        time_limit_seconds: this.form.timeLimits,
        info_graphic: this.form.infoGraphic
      };
      this.submiting = true;
      this.isLoading = true;
      const URI = "v1/training/addquestion",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        };
      const Result = HTTP("post", URI, this.formData, headers, null, true);
      return Result.then(response => {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.$v.$reset();
      }).catch(err => {
        this.isLoading = false;
        this.submiting = false;
      });
    },
    postData(index) {
      this.createQuestionApiCall();
      (this.form.selected = null),
        (this.form.selectedQuestionType = 1),
        (this.form.timeLimits = null),
        (this.form.enterQuestion = null),
        (this.form.enterScore = null),
        (this.form.questionLevel = null),
        (this.form.shuffleAnswer = null);
      this.$v.$reset();
      this.rowDataMultiChoice.splice(index);
    },
    // file upload
    vsuccess(file, response) {
      // console.log("file, response", file, response);

      this.form.infoGraphic = file.dataURL;
    },
    getQuestionType() {
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/training/getquestiontypes", {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.response;
          this.isLoading = false;
          return items.map(item => {
            const { type, id } = item;
            return { text: type, value: id };
          });
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    }
  }
};
</script>

<style>
</style>
